import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { VotaLayoutComponent } from './vota-layout/vota-layout.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
  declarations: [AuthLayoutComponent, VotaLayoutComponent],
  imports: [CommonModule, RouterModule, SharedModule, MatSidenavModule],
})
export class LayoutsModule {}
